export default function RemoveNonNumericCharacters(input: string): string {
  return input.replace(/[^\d]/g, "");
}
